<template>
  <div style="text-align: center;">
    <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered"></video>
  </div>
</template>

<script>
import videojs from 'video.js'

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      player: null,
      ratio: 9 / 16
    }
  },
  methods: {
    adjustSize () {
      const width = document.documentElement.clientWidth
      this.player.width(width)
      this.player.height(width * this.ratio)
    }
  },
  mounted () {
    const options = this.options
    if (this.miiafwlibs_getBrowser() === 'ie') {
      require('videojs-flash')
      require('@brightcove/videojs-flashls-source-handler')
      options.flash = {
        // swf: 'https://cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.2/video-js.swf'
        swf: 'videojs-swf/dist/video-js.swf'
      }
      options.hls = {
        mode: 'flash'
      }
    }
    if (Object.prototype.hasOwnProperty.call(options, 'miiaAspectRatio')) {
      this.ratio = options.miiaAspectRatio
    }
    this.player = videojs(this.$refs.videoPlayer, options, () => {
      this.adjustSize()
      window.addEventListener('resize', this.adjustSize)
    })
    // if (this.miiafwlibs_getBrowser() === 'ie') {
    //   require('videojs-flash')
    //   require('@brightcove/videojs-flashls-source-handler')
    //   this.options.flash = {
    //     // swf: 'https://cdnjs.cloudflare.com/ajax/libs/videojs-swf/5.4.2/video-js.swf'
    //     swf: 'videojs-swf/dist/video-js.swf'
    //   }
    //   this.options.hls = {
    //     mode: 'flash'
    //   }
    // }
    // if (Object.prototype.hasOwnProperty.call(this.options, 'miiaAspectRatio')) {
    //   this.ratio = this.options.miiaAspectRatio
    // }
    // this.player = videojs(this.$refs.videoPlayer, this.options, () => {
    //   this.adjustSize()
    //   window.addEventListener('resize', this.adjustSize)
    // })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.adjustSize)
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
